'use strict';

angular.module('admin').controller('AdminHistoricUserDataController',
	['$scope', 'AdminData', 'Authentication', 'Utilities', '$stateParams', '$window',
		function($scope, AdminData, Authentication, Utilities, $stateParams, $window) {
			$scope.authentication = Authentication;
			$scope.data = {
				userId: $stateParams.userId,
				userInfo: undefined,
				stats: []
			};

			$scope.processing = false;


			/**
			 * Load all the data
			 */
			$scope.init = function() {
				AdminData.getHistoricData({userId: $scope.data.userId}, function (historicData) {

					// Remove data like $promise and others
					historicData = JSON.parse(JSON.stringify(historicData));

					var dataFields = ['mau', 'apiRequests'];

					// Bring in easier format to display
					for (var year in historicData) {
						for (var month in historicData[year]) {
							var entry = {
								date: year + '/' + month,
								data: historicData[year][month]
							};

							// Make sure that always all fields exist
							for (var i=0;i<dataFields.length;i++) {
								var fieldName = dataFields[i];
								if (!entry.data.hasOwnProperty(fieldName)) {
									entry.data[fieldName] = 0;
								}
							}

							$scope.data.stats.push(entry);
						}
					}

				}, function (err) {
					console.log(err);
					Utilities.showMessage(
						'Problem!',
						'Problem loading data',
						'error'
					);
				});

				// Query also the user information that we can display the name
				// of the person we display the stats for
				AdminData.userInfo({userId: $scope.data.userId}, function (userInfo) {
					$scope.data.userInfo = userInfo;
				}, function (err) {
					console.log(err);
					Utilities.showMessage(
						'Problem!',
						'Problem loading user info',
						'error'
					);
				});
			};


			$scope.init();
		}
	]);
